import Vue from 'vue'
import { AclInstaller, AclCreate, AclRule } from 'vue-acl'
import router from '../router'
// import store from '../store/index'

Vue.use(AclInstaller)

export default new AclCreate({
  initial: 'load',
  notfound: {
    path: '/error/403',
    forwardQueryParams: true,
  },
  router,
  acceptLocalRules: true,
  globalRules: {
    //test rules
    loading: new AclRule('load').generate(),
    IT: new AclRule('IT').generate(),
    isGoodMode: new AclRule('good-mode-access')
      .or('load').generate(),
    tenderAdmin: new AclRule('tenderAdmin').generate(),
    isAdmin: new AclRule('admin')
      .or('load').generate(),
    isSuperuser: new AclRule('superuser')
      .or('load')
      .or('admin').generate(),
    isAnalyst: new AclRule('analyst')
      .or('load')
      .or('superuser')
      .or('admin').generate(),
    isUser: new AclRule('user')
      .or('load')
      .or('analyst')
      .or('superuser')
      .or('admin').generate(),
    onlyApps: new AclRule('only_purchasing')
      .or('load')
      .or('user')
      .or('analyst')
      .or('superuser')
      .or('admin').generate(),
    onlyTenders: new AclRule('only_tenders')
      .or('load')
      .or('user')
      .or('analyst')
      .or('superuser')
      .or('admin')
      .generate(),
    onlyAgreement: new AclRule('commercialAgreement')
      .generate(),
    onlyMyTenders: new AclRule('only_my_tenders')
      .generate(),
    stopListEdit: new AclRule('stop_list_edit')
      .or('load')
      .or('user')
      .or('analyst')
      .or('superuser')
      .or('admin').generate(),
    stopListView: new AclRule('stop_list_view')
      .or('stop_list_edit')
      .or('load')
      .or('user')
      .or('analyst')
      .or('superuser')
      .or('admin').generate(),
    isSecurity: new AclRule('security')
      .generate(),
    tendersView: new AclRule('tenders_view')
      .or('security')
      .or('only_tenders')
      .or('load')
      .or('user')
      .or('analyst')
      .or('superuser')
      .or('admin').generate(),
    isPublic: new AclRule('public')
      .or('security')
      .or('only_purchasing')
      .or('tenders_view')
      .or('only_tenders')
      .or('load')
      .or('user')
      .or('analyst')
      .or('superuser')
      .or('no_access')
      .or('admin').generate(),
    noAccess: new AclRule('no_access').generate()
  },

  // middleware: async acl => {
  //   let currentOrganization = store.getters['getCurrentOrganization'],
  //     user = store.getters['GET_USER']
  //   if (!currentOrganization || !Object.entries(currentOrganization).length) {
  //     acl.change( Object.entries(user).length ?  'load'  : 'public' )
  //   }
  // }
})
